<template>
	<modal-component
		v-if="modalComponentShown"
		:onClose="onClose"
		:buttons="buttons"
		class="reset-dialog"
	>
		<div class="popup-wrapper">
			<v-container>
				<v-flex xs12 >
					<div class="close-image">
						<img :src="`${staticPath}kiosk/images/icons/close-pp-icon.svg`" />
					</div>
					<div class="popup-title">{{$t("shopComponents.gt3.restartAppDialog.inactiveMessage")}}</div>
					<div class="popup-subtitle">
						<p v-if="dialogTime">{{$t("shopComponents.gt3.restartAppDialog.continueQuestion1")}} {{dialogTime}} {{timeUnit}}{{$t("shopComponents.gt3.restartAppDialog.continueQuestion2")}} </p>
					</div>
				</v-flex>
			</v-container>
		</div>
	</modal-component>
</template>

<script>
import ModalComponent from "../../UtilityComponents/ModalComponent";
import * as Utils from "../../../libraries/utils";
export default {
	name: "RestartAppDialog",
	props: ["modalComponentShown", "closeCallback", "dialogTime"],
	components: {
		ModalComponent
	},
	computed: {
		staticPath() {
			return Utils.getStaticPath();
		},
		timeUnit(){
			const self = this;
			return self.dialogTime > 1 ? self.$t("shopComponents.gt3.productCatalog.productCatalogWrapper.seconds"): self.$t("shopComponents.gt3.productCatalog.productCatalogWrapper.second");
		},
		buttons() {
			const self = this;

			return {
				async continue() {
					self.closeCallback();
				}
			};
		}
	},
	data() {
		const self = this;

		return {
			onClose: self.closeCallback
		};
	},
	methods: {

	}
};
</script>

<style scoped lang="scss">


</style>
